import { inject, Injectable } from '@angular/core';
import { HttpService } from '../shared/services/http.service';
import { catchError, firstValueFrom, map, Observable, Subscriber, tap, TeardownLogic, throwError } from 'rxjs';
import { MasterdataRequestDTO } from '../models/MasterdataRequestDTO.model';
import { FileDTO } from '../models/FileDTO.model';
import { DeviceDTO } from '../models/DeviceDTO.model';
import { PlanDeviceDTO } from '../models/PlanDeviceDTO.model';
import { ApiRoutesEnum } from '../shared/enums/ApiRoutes.enum';
import { MassImportSimsResponse } from '../models/MassImportSimsResponse';
import { ResponseDataFile } from '../shared/models/ApiResponse';
import { PlanAvailableDTO } from '../models/PlanAvailableDTO.model';
import { ResponseBase } from '../models/ResponseBase';
import { UnassignedCustomerDeviceDto } from '../models/UnassignedCustomerDeviceDto';
import { DataFile } from '../models/DataFile.model';
import { GetListPlansAvailablesRequest } from '../models/GetListPlansAvailablesRequest.model';
import { AlertService } from '../shared/services/alert.service';
import { HttpClient } from '@angular/common/http';
import { ApiResponse, PageableRequest as PagableRequest, PageableResponse as PagableResponse, PageArray } from '../models/ApiResponse';

/** Параметры запроса на получение текущего журнала аудита */
export interface LoadAuditDataRequestDTO extends PagableRequest {
    /** Идентификатор клиента */
    customerId: number;
    /** Начало периода отбора */
    fromDate?: string;
    /** Конец периода отбора */
    toDate?: string;
}

export interface AuditDataDTO {
    date: string;

    eventTypeId: number;
    eventType: string;

    userId: number;
    user: string;
    details: string;
}

@Injectable({ providedIn: 'root' })
export class AuditService {

    private http = inject(HttpService);

    loadAuditDataAsync(request: LoadAuditDataRequestDTO) {
        return this.http.postAsync<PageArray<AuditDataDTO>>(ApiRoutesEnum.LoadAuditData, request);
    } 
}
